import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card.tsx';
import { Check, Copy, ExternalLink } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { buttonVariants } from '@/components/buttons/actionButtonVariants.ts';
import { cn } from '@/lib/utils.ts';
import { useIsMobile } from '@/hooks/use-mobile.tsx';

interface ChatLinkCardProps {
  chatLink: string;
}

const ChatLinkCard = ({ chatLink }: ChatLinkCardProps) => {
  const [copied, setCopied] = useState(false);
  const isMobile = useIsMobile();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(chatLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const copyCaption = copied ? 'Skopiowano' : 'Kopiuj';

  return (
    <Card>
      <CardHeader>
        <CardTitle>Chat wyjazdu</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-4">
        <CardDescription>
          Organizator utworzył czat dla tego wyjazdu - dołącz poprzez link lub
          zeskanuj QR code swoim telefonem.
        </CardDescription>
        <div className="rounded-md border border-neutral-200 p-3">
          <QRCodeSVG value={chatLink} size={120} />
        </div>

        <div className="flex w-full items-center gap-1">
          <span className="min-w-0 flex-1 truncate rounded-md bg-neutral-50 px-3 py-2 text-sm text-neutral-600">
            {chatLink}
          </span>
          {/* Na telefonie napisy zabierałyby miejsce linkowi — zostają same znaki. */}
          <ActionButton
            tone="outline"
            size="sm"
            iconOnly={isMobile}
            aria-label={isMobile ? copyCaption : undefined}
            onClick={handleCopy}
          >
            {copied ? <Check /> : <Copy />}
            {!isMobile && copyCaption}
          </ActionButton>
          <a
            href={chatLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={isMobile ? 'Otwórz' : undefined}
            className={cn(
              buttonVariants({
                tone: 'outline',
                size: 'sm',
                iconOnly: isMobile,
              }),
            )}
          >
            <ExternalLink />
            {!isMobile && 'Otwórz'}
          </a>
        </div>
      </CardContent>
    </Card>
  );
};

export default ChatLinkCard;
